import { render } from "./AanmeldenFeestdagen.vue?vue&type=template&id=d11811ca"
import script from "./AanmeldenFeestdagen.vue?vue&type=script&lang=js"
export * from "./AanmeldenFeestdagen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__